import { render, staticRenderFns } from "./ExperienceBox.vue.html?vue&type=template&id=34d36cea&scoped=true&"
import script from "./ExperienceBox.component.js?vue&type=script&lang=vueJs&"
export * from "./ExperienceBox.component.js?vue&type=script&lang=vueJs&"
import style0 from "./ExperienceBox.scoped.scss?vue&type=style&index=0&id=34d36cea&prod&lang=vueScss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34d36cea",
  null
  
)

export default component.exports